import { StyledFilter } from './StyledFilter';
import { Select, DatePicker, Input } from 'antd';
import React, { useEffect, useMemo, useState } from 'react';
import { connect, useDispatch } from 'react-redux';
import { GET_LIST_AUTHOR_REQUEST } from '../constant';
import moment from 'moment';
import jwtDecode from 'jwt-decode';
const { RangePicker } = DatePicker;

const { Option } = Select;
const Filter = ({ authors, onSubmit, filter, children }) => {
  let languageOptions = [
    { value: 'all', label: 'All' },
    { value: 'th', label: 'Thai (Thailand)' },
    { value: 'en', label: 'English (Thailand)' },
    { value: 'my', label: 'English (Malaysia)' },
  ];

  const token = sessionStorage.getItem('token');
  if (token) {
    const decoded = jwtDecode(token);
    switch (decoded.dbName) {
      case 'MY':
        languageOptions = languageOptions.filter(option => option.value === 'my');
        break;
      case 'TH':
        languageOptions = languageOptions.filter(option => option.value !== 'my');
        break;
    }
  }

  const formatDate = ['DD/MM/YYYY', 'YYYY/MM/DD'];

  const [formData, setFormData] = useState({
    searchValue: filter.searchValue || '',
    language: filter.language || languageOptions[0].value,
    author: filter.author || -1,
    datePublicStart: filter.datePublicStart,
    datePublicEnd: filter.datePublicEnd,
  });

  const handleChange = (type, value) => {
    const data = { ...formData, [type]: value };
    setFormData(data);
    onSubmit(data);
  };

  const handleDatePublicChange = dates => {
    const datePublicStart = dates[0] ? moment(dates[0], formatDate[0]).format(formatDate[1]) : null;
    const datePublicEnd = dates[1] ? moment(dates[1], formatDate[0]).format(formatDate[1]) : null;
    const data = { ...formData, datePublicStart, datePublicEnd };
    setFormData(data);
    onSubmit(data);
  };

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch({
      type: GET_LIST_AUTHOR_REQUEST,
    });
  }, []);

  const languageOptionsElements = useMemo(
    () =>
      languageOptions.map(option => (
        <Option key={option.value} value={option.value}>
          {option.label}
        </Option>
      )),
    [languageOptions],
  );

  return (
    <StyledFilter>
      {/* <div className="filter-popup"> */}
      <div className="filter-popup-button">{children}</div>
      <div className="search-value">
        <label>Search&nbsp;Value:</label>
        <Input
          className="search-value-input"
          placeholder="Search Value"
          value={formData.searchValue}
          onChange={e => handleChange('searchValue', e.target.value)}
        />
      </div>
      <div className="language">
        <label>Language&nbsp;(Region):</label>
        <div className="language-input">
          <Select
            value={formData.language}
            style={{ width: '100%' }}
            onChange={value => {
              handleChange('language', value);
            }}
          >
            {languageOptionsElements}
          </Select>
        </div>
      </div>
      <div className="author">
        <label>Author</label>
        <div className="author-input">
          <Select
            value={formData.author}
            style={{ width: '100%' }}
            onChange={value => {
              handleChange('author', value);
            }}
          >
            <Option value={-1}>All</Option>
            <Option value={0}>N/A</Option>
            {authors?.data &&
              authors.data.map(author => (
                <Option key={author.authorId} value={author.authorId}>
                  {author.nickName}
                </Option>
              ))}
          </Select>
        </div>
      </div>
      <div className="date-public">
        <label style={{ marginRight: '10px' }}>Publish Date:</label>
        <RangePicker
          allowEmpty={[true, true]}
          value={[
            formData.datePublicStart ? moment(formData.datePublicStart, formatDate[1]) : null,
            formData.datePublicEnd ? moment(formData.datePublicEnd, formatDate[1]) : null,
          ]}
          format={formatDate}
          onChange={(dates, dateStrings) => {
            handleDatePublicChange(dateStrings);
          }}
        />
      </div>
      {/* <Button type="submit" onClick={handleSubmit}>Filter</Button> */}
      {/* </div> */}
    </StyledFilter>
  );
};

export default connect(state => ({
  isWaitingSave: state.post.isWaitingSave,
  postDetail: state.post.postDetail,
  authors: state.post.authors,
  filter: {
    searchValue: state.post.searchValue,
    language: state.post.language,
    author: state.post.author,
    datePublicStart: state.post.datePublicStart,
    datePublicEnd: state.post.datePublicEnd,
  },
}))(Filter);
